import React, { Suspense } from 'react';
import './templates/help.css';
import CommunicatorPatientPortalHelpTemplate from './templates/CommunicatorPatientPortal';
import AppleHealthTemplate from './templates/AppleHealthHelp';
import AthenanetHelpTemplate from './templates/AthenaNetHelp';
import PatientOidcHelpTemplate from './templates/PatientOidcHelp';
import PatientSmartHelpTemplate from './templates/PatientSmartHelp';
import HelpTemplate from './templates/Help';

import { useQuery } from '../lib/router-utils';


export default function Index() {

  const query = useQuery();
  const helpTemplateName = query.get('help_template');
  const clientId = query.get('client_id');

  function getComponentToRender(helpTemplateName) {
    switch (helpTemplateName) {
      case 'apple-health-help':
        return AppleHealthTemplate;
      case 'communicator-patient-portal-help':
        return CommunicatorPatientPortalHelpTemplate;
      case 'patient-oidc-help':
        return PatientOidcHelpTemplate;
      case 'patient-smart-help':
        return PatientSmartHelpTemplate;
      case 'athenanet-help':
        return AthenanetHelpTemplate;
      default:
        return HelpTemplate;
    }
  }
  const ComponentToRender = getComponentToRender(helpTemplateName);
  return (
    <Suspense fallback={'Loading ...'}>
      <ComponentToRender profileManageLink={`/profile/manage?client_id=${clientId}#profile`}/>
    </Suspense>
  );
}



